import { MenuItem, MenuItemProps } from '@mui/material';

import { Role } from '../types';
import { useAuthContext } from '../hooks';

interface RoleRestrictedMenuItemProps extends MenuItemProps {
  requiredRoles: string[];
}

/**
 * A role restricted MUI menu item. This is needed over RoleBoundary due to the way that MUI works
 * (direct use of menu item is required so cannot be passed as children)
 */
export default function RoleRestrictedMenuItem({
  requiredRoles,
  ...rest
}: RoleRestrictedMenuItemProps) {
  const { user } = useAuthContext();

  const hasRole = user?.roles?.some((userRole: Role) => requiredRoles.includes(userRole.name));
  return hasRole ? <MenuItem {...rest} /> : null;
}
